import { UserRoles, WIDGETS_BY_ROLE } from "@/services/user-auth/user-roles";
import type { ViewId } from "@/shared/types/common";

export const getWidgetColorClassName = (viewId: ViewId) => {
	if (WIDGETS_BY_ROLE[UserRoles.BRONZE].includes(viewId)) {
		return "hover:bg-[var(--bronze)]";
	}
	if (WIDGETS_BY_ROLE[UserRoles.SILVER].includes(viewId)) {
		return "hover:bg-[var(--silver)]";
	}
	if (WIDGETS_BY_ROLE[UserRoles.GOLD].includes(viewId)) {
		return "hover:bg-[var(--gold)]";
	}
	if (WIDGETS_BY_ROLE[UserRoles.PLATINUM].includes(viewId)) {
		return "hover:bg-[var(--platinum)]";
	}
};
